import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import MuiSnackbar from '@mui/material/Snackbar';

import { CHILDREN_PROP_TYPES } from 'propTypes';

const StyledSnackbar = styled(MuiSnackbar)(({ theme }) => ({
  '&.MuiSnackbar-root': {
    [theme.breakpoints.down('lg')]: {
      bottom: theme.spacing(11.25),
      left: theme.spacing(2.5),
      right: theme.spacing(2.5)
    },
    '& .MuiSnackbarContent-root': {
      backgroundColor: theme.palette.text.secondary
    }
  }
}));

function Snackbar({ open, message, onClose }) {
  return (
    <StyledSnackbar
      open={open}
      onClose={onClose}
      autoHideDuration={3000}
      message={message}
      anchorOrigin={{
        horizontal: 'left',
        vertical: 'bottom'
      }}
    />
  );
}

Snackbar.defaultProps = {
  open: false,
  onClose: () => {}
};

Snackbar.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  message: CHILDREN_PROP_TYPES.isRequired
};

export default Snackbar;
